import { environment } from '../../../environments/environment';

export const rootUrl = environment.apiUrl;